// @ts-nocheck

import { createSelector } from 'reselect';

import { getIsGridFromProps } from '../../selectors/_propsGetters_';
import {
  selectEntitiesMatchesEntityPeriodId,
  selectEntitiesMatchesEntitySportId,
} from '../../selectors/entities/matches/entitiesMatchesPrimary.selector';
import { selectMatchTimeInSeconds } from '../../selectors/match.selector';
import { SportIds } from '../../types/sports';
import { getType } from '../../utils/timer';

const makeTimerPeriodIdPropsSelector = () => {
  const selectSportId = createSelector([getIsGridFromProps, selectEntitiesMatchesEntitySportId], (isGrid, sportId) =>
    isGrid ? SportIds.SOCCER : sportId,
  );

  const selectType = createSelector(
    [selectMatchTimeInSeconds, selectEntitiesMatchesEntityPeriodId, selectSportId],
    (seconds, periodId, sportId) => getType(sportId, periodId),
  );

  return createSelector([selectMatchTimeInSeconds, selectType], (seconds, type) => ({
    seconds,
    type,
  }));
};

export default makeTimerPeriodIdPropsSelector;
